<template>
  <div>
    <el-dialog :visible.sync="showLogs" width="60%" class="el-dialog_log" :before-close='handleConfirm'>
      <h2><i class="el-icon-message-solid" style="color: #337ecb"></i> 更新日志 </h2>
      <el-form :model="newLogData">
        <el-form-item>
          <ul style="overflow-y: auto;max-height: 500px;min-height: 300px">
            <li class="logDetail" style="list-style: square inside;margin-top: 10px"
                v-for="(itemInner,index) in newLogData.update">
<!--              新格式日志-->
            <span v-if="typeof itemInner==='object'">
              <span style="font-size: larger">{{ itemInner.title }}:</span>
              <ul>
              <li v-for="(item,i) in itemInner.content" style="line-height: 32px;font-size: 15px">
                <i class="iconfont icon-dian" ></i>{{ i + 1 }}、<span v-html="item"></span>
              </li>
                </ul>
            </span>

              <span v-else><i class="iconfont icon-dian"></i>{{ index + 1 }}、{{ itemInner }}</span>
            </li>
          </ul>
          <div style="display: flex;justify-content: flex-end;margin-top: 30px">
            <el-button mini type="success" style="margin-right: 50px" @click="handleConfirm">我知道了</el-button>
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {logsData} from "@/utils/logsData";
import {getDataInLocalStorage} from "@/utils/localStorage";

const  otherApiUrl=process.env.VUE_APP_OTHER_API
export default {
  name: 'DisplaysLogs',
  props:['showDialog'],
  data() {
    return {
      showLogs:this.showDialog,
      // 最新日志信息
      newLogData: logsData[0] ,
    }
  },
  methods: {
    // 确认读取新日志
    handleConfirm() {
      fetch(`${otherApiUrl}/person_api/version-log-read/confirm?uuid=${getDataInLocalStorage('uuid')}&space=bs`, {
        method: 'get',
      }).then(res => res.json()).then(res1 => {
        if (res1.code !== 200) {
          this.$messageUi.error(res1.msg)
        } else {
          this.showLogs = false
        }
      })
    }
  }
}
</script>

<style scoped>
::marker {
  color: #337ecb;
  font-size: 22px;
}

:deep(.el-dialog__header) {
  margin: 0;
  padding: 15px;
}

:deep(.el-dialog__body) {
  margin-top: 0;
  padding-top: 0;
}

</style>
